export default {
  severities: 'Poziomy ważności',
  allSeverities: 'Wszystkie poziomy ważności',
  doesIncludeHiddenAlarms: 'Uwzględnij ukryte alarmy',
};
